import React from 'react';
import { Modal } from './Modal';
import './PublicUrlCelebrationModal.css';

interface PublicUrlCelebrationModalProps {
  publicUrl: string | null;
  onClose: () => void;
}

export const PublicUrlCelebrationModal: React.FC<PublicUrlCelebrationModalProps> = ({ 
  publicUrl, 
  onClose 
}) => {
  if (!publicUrl) return null;

  return (
    <Modal
      isOpen={!!publicUrl}
      onClose={onClose}
      title="🚀 Public URL Generated!"
      hideCloseButton={false}
      actionButtons={
        <button
          type="button"
          onClick={onClose}
          className="btn btn-primary"
        >
          Got it!
        </button>
      }
    >
      <div className="celebration-modal">
        <div className="celebration-success">
          <div className="celebration-icon">🎉</div>
          <p>Your list is now publicly shareable! Anyone with this link can view your list in read-only mode.</p>
        </div>
        
        <div className="celebration-url-section">
          <label>Public URL:</label>
          <div className="celebration-url-display">
            <input
              type="text"
              value={publicUrl}
              readOnly
              className="celebration-url-input"
              onClick={(e) => e.currentTarget.select()}
            />
            <button
              type="button"
              className="btn btn-secondary celebration-copy-btn"
              onClick={() => {
                navigator.clipboard.writeText(publicUrl);
              }}
              title="Copy to clipboard"
            >
              Copy
            </button>
          </div>
        </div>
        
        <div className="celebration-tips">
          <h4>💡 Sharing Tips:</h4>
          <ul>
            <li>Share this URL with anyone to give them read-only access</li>
            <li>They can view all items, comments, and progress</li>
            <li>You can disable public sharing anytime in list settings</li>
          </ul>
        </div>
      </div>
    </Modal>
  );
};